<template>
  <div class="col-12 p-0">
    <button @click="showSupport" class="btn btn-sm btn-danger w-100 rounded">Precisa de Ajuda?</button>
    <form-support v-if="showing" @success="showSupport"/>
  </div>
</template>

<script>
import FormSupport from './Form'

export default {
  components: {
    "form-support": FormSupport
  },
  data () {
    return {
      showing: false
    }
  },
  methods: {
    showSupport: function () {
      this.showing = !this.showing
    }
  }
}
</script>

<style>

</style>
